import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;
const checkPassword = () => {
    return helpers.regex('alphaNum', /^[A-Za-z0-9]*$/)
};

const checkString = () => {
    return helpers.regex('alpha', /^[a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ\-]*$/)
};

const checkNumber = () => {
    return helpers.regex('alpha', /^[0-9]*$/);
};

Vue.use(SimpleVueValidation);
export default {
    data() {
        return{
            c_idx: '',
            content : ''
        }
    },
    validators: {
        content: function (value) {
            return Validator.value(value)
                .required('내용을 입력해주세요.')
                .custom(
                    () => {
                        let content = value.replace(/<(\/p|br|p)([^>]*)>/gi,"");
                        if(content.length === 0) {
                            return '내용을 입력해주세요.'
                        }
                    }
                )
        },
        c_idx: function (value) {
            return Validator.value(value)
                .required('국가를 입력해주세요.')
        },
    },
    methods:{
    }
}
